/**
 * Normalize a product variant SKU before it is persisted.
 *
 * - Trims leading and trailing whitespace.
 * - Collapses every run of internal whitespace into a single space.
 * - Uppercases the value.
 *
 * A whitespace-only (or empty/nullish) value normalizes to an empty string so
 * each surface's existing required-SKU check can reject it before submit.
 * A single internal space is preserved (e.g. "CI2666 100" stays "CI2666 100").
 *
 * @param {string} value raw SKU input
 * @returns {string} normalized SKU
 */
export const normalizeSku = value => {
  if (value === null || value === undefined) return '';
  return String(value)
    .trim()
    .replace(/\s+/g, ' ')
    .toUpperCase();
};
